export default process.env.NODE_ENV === 'development' || window.location.hostname.endsWith('.test')
